import CwLoadModules from '@customjs/module-loader.js';

const CwThemeFramework = {
    async generalFns() {
        const office = document.querySelector('.select-office');
        if (office) {
            this.loadLocations(office);
            office.addEventListener('change', () => this.loadLocations(office));
        }

        //(For Contact page Location Widget)
        const officeContact = document.querySelector('.select-office-contact');
        if (officeContact) {
            this.loadLocationsContact(officeContact);
            officeContact.addEventListener('change', () => this.loadLocationsContact(officeContact));
        }

        this.stickyHeader();
        this.ctaSectionLayout();
    },

    /**
     * Sticky Header
     *
     * Uses `position: sticky` (no layout shift) and an IntersectionObserver
     * on a sentinel element to add the `is-stuck` class once the header has
     * scrolled to the top, enabling shadow/visual changes without CLS.
     */
    stickyHeader() {
        const header = document.querySelector('.header--sticky');
        if (!header) return;

        const sentinel = document.querySelector('.sticky-sentinel');
        if (!sentinel) return;

        const observer = new IntersectionObserver(
            ([entry]) => {
                header.classList.toggle('is-stuck', !entry.isIntersecting);
            },
            { threshold: [0] }
        );

        observer.observe(sentinel);
    },

    /**
     * Practice area CTA image overflow spacing
     */
    ctaSectionLayout() {
        const CTA_IMAGE_HEIGHT = 936;
        const DESKTOP_BREAKPOINT = 1200;

        const updateCtaSectionLayout = () => {
            document.querySelectorAll('.cta-section').forEach((section) => {
                const content = section.querySelector('.content');
                const inner = section.querySelector('.cta-section__inner');

                if (!content || !inner || window.innerWidth < DESKTOP_BREAKPOINT) {
                    inner?.style.removeProperty('--cta-image-overflow');
                    return;
                }

                const contentHeight = content.getBoundingClientRect().height;
                const imageOverflow = Math.max(0, CTA_IMAGE_HEIGHT - contentHeight);

                inner.style.setProperty('--cta-image-overflow', `${imageOverflow}px`);
            });
        };

        const contents = document.querySelectorAll('.cta-section .content');

        if (!contents.length) {
            return;
        }

        updateCtaSectionLayout();

        const observer = new ResizeObserver(updateCtaSectionLayout);
        contents.forEach((content) => observer.observe(content));

        window.addEventListener('resize', updateCtaSectionLayout);
        window.addEventListener('load', updateCtaSectionLayout);
    },

    /**
     * Load Locations
     */
    async loadLocations(locationID) {
        if (locationID) {
            CwLoadModules.modals().then((modals) => {
                const officeHours = new modals('.cw-modal');
                officeHours.init();
            });               
            const apiURL = `/api/location/${locationID.value}/`;                     
            //const apiURL = `http://127.0.0.1/levininjuryfirm.cwdevelop.com/api/location/${locationID.value}/`;            
            const officeBox = document.querySelector('.office-info');
            const officeHours = document.querySelector('.opening-hours');
            const officeInfo = await fetch(apiURL);
            const officeDetails = await officeInfo.json();

            if (officeDetails.success) {
                const {
                    firmName,
                    directionURL,
                    infoURL,
                    city,
                    state,
                    zip,
                    location_address_1,
                    location_address_2,
                    phone,
                    email,
                    toll_free_number,
                    location_fax,
                    footer_map,
                    monday_hours,
                    tuesday_hours,
                    wednesday_hours,
                    thursday_hours,
                    friday_hours,
                    saturday_hours,
                    sunday_hours,
                } = officeDetails.data;

                const firmNameHTML = firmName ? `<strong>${firmName}</strong>` : '';
                const address1HTML = location_address_1 ?
                    `<span>${location_address_1}</span>` :
                    '';
                const address2HTML = location_address_2 ?
                    `<span>${location_address_2}</span>` :
                    '';
                const phoneHTML = phone ?
                    `<a href="tel:${phone}" class="ctm-no-swap" aria-label="Phone">Local: ${phone}</a>` :
                    '';
                const toll_free_numberHTML = toll_free_number ?
                    `<a href="tel:${toll_free_number}" aria-label="Phone">Toll Free: ${toll_free_number}</a>` :
                    '';    
                const emailHTML = email ?
                    `<a href="mailto:${email}" aria-label="Email Address">${email}</a>` :
                    '';
                const officeInfoButtons = `<div class="office-info__buttons">
                   
                    <a href="${infoURL}" aria-label="Direction Link">Info <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                      <g clip-path="url(#clip0_647_772)">
                        <path d="M12.6667 0H3.33333C1.49533 0 0 1.49533 0 3.33333V12.6667C0 14.5047 1.49533 16 3.33333 16H12.6667C14.5047 16 16 14.5047 16 12.6667V3.33333C16 1.49533 14.5047 0 12.6667 0ZM12.6667 9.33333C12.6667 9.70133 12.3687 10 12 10C11.6313 10 11.3333 9.70133 11.3333 9.33333V5.60933L4.47133 12.4713C4.34133 12.6013 4.17067 12.6667 4 12.6667C3.82933 12.6667 3.65867 12.6013 3.52867 12.4713C3.268 12.2107 3.268 11.7893 3.52867 11.5287L10.3907 4.66667H6.66667C6.298 4.66667 6 4.368 6 4C6 3.632 6.298 3.33333 6.66667 3.33333H10.6667C11.7693 3.33333 12.6667 4.23067 12.6667 5.33333V9.33333Z" fill="#28A8C8"/>
                      </g>
                          <defs>
                            <clipPath id="clip0_647_772">
                              <rect width="16" height="16" fill="white"/>
                            </clipPath>
                          </defs>
                        </svg>
                    </a>

                    <a href="${directionURL}" target="_blank" aria-label="Direction Link">Directions <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                      <g clip-path="url(#clip0_647_772)">
                        <path d="M12.6667 0H3.33333C1.49533 0 0 1.49533 0 3.33333V12.6667C0 14.5047 1.49533 16 3.33333 16H12.6667C14.5047 16 16 14.5047 16 12.6667V3.33333C16 1.49533 14.5047 0 12.6667 0ZM12.6667 9.33333C12.6667 9.70133 12.3687 10 12 10C11.6313 10 11.3333 9.70133 11.3333 9.33333V5.60933L4.47133 12.4713C4.34133 12.6013 4.17067 12.6667 4 12.6667C3.82933 12.6667 3.65867 12.6013 3.52867 12.4713C3.268 12.2107 3.268 11.7893 3.52867 11.5287L10.3907 4.66667H6.66667C6.298 4.66667 6 4.368 6 4C6 3.632 6.298 3.33333 6.66667 3.33333H10.6667C11.7693 3.33333 12.6667 4.23067 12.6667 5.33333V9.33333Z" fill="#28A8C8"/>
                      </g>
                      <defs>
                        <clipPath id="clip0_647_772">
                          <rect width="16" height="16" fill="white"/>
                        </clipPath>
                      </defs>
                    </svg>
                    </a>

               </div>`;

                const footerMapHTML = footer_map ?
                    `<figure><a href="${directionURL}" target="_blank" aria-label="Direction Link"><img src="${footer_map}" alt="${firmName}" /><svg width="60" height="60" viewBox="0 0 60 60" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <rect width="60" height="60" rx="30" fill="#28A8C8" fill-opacity="0.9"/>
                        <path d="M30 13.5C23.3657 13.5 18 18.8051 18 25.3644C18 32.4322 25.5771 42.178 28.6971 45.8898C29.3829 46.7034 30.6343 46.7034 31.32 45.8898C34.4229 42.178 42 32.4322 42 25.3644C42 18.8051 36.6343 13.5 30 13.5ZM30 29.6017C27.6343 29.6017 25.7143 27.7034 25.7143 25.3644C25.7143 23.0254 27.6343 21.1271 30 21.1271C32.3657 21.1271 34.2857 23.0254 34.2857 25.3644C34.2857 27.7034 32.3657 29.6017 30 29.6017Z" fill="#030919"/>
                        </svg>
                     </a></figure>` :
                    '';

                const address = `${firmNameHTML}
               <address>
                   ${address1HTML}
                   ${address2HTML}
                   <span>${city}, ${state} ${zip}</span>
               </address>
               ${phoneHTML}<br>
               ${toll_free_numberHTML}<br>
               ${emailHTML}${officeInfoButtons}
               ${footerMapHTML}`;
                officeBox.innerHTML = address;

                const mondayHoursHTML = monday_hours ?
                    `<tr><td class="day">Monday</td><td class="time"><span>${monday_hours}</span></td></tr>` :
                    '';
                const tuesdayHoursHTML = tuesday_hours ?
                    `<tr><td class="day">Tuesday</td><td class="time"><span>${tuesday_hours}</span></td></tr>` :
                    '';
                const wednesdayHoursHTML = wednesday_hours ?
                    `<tr><td class="day">Wednesday</td><td class="time"><span>${wednesday_hours}</span></td></tr>` :
                    '';
                const thursdayHoursHTML = thursday_hours ?
                    `<tr><td class="day">Thursday</td><td class="time"><span>${thursday_hours}</span></td></tr>` :
                    '';
                const fridayHoursHTML = friday_hours ?
                    `<tr><td class="day">Friday</td><td class="time"><span>${friday_hours}</span></td></tr>` :
                    '';
                const saturdayHoursHTML = saturday_hours ?
                    `<tr><td class="day">Saturday</td><td class="time"><span>${saturday_hours}</span></td></tr>` :
                    '';
                const sundayHoursHTML = sunday_hours ?
                    `<tr><td class="day">Sunday</td><td class="time"><span>${sunday_hours}</span></td></tr>` :
                    '';

                const hoursOffice = `<table>
                              <tbody>
                              ${mondayHoursHTML}
                              ${tuesdayHoursHTML}
                              ${wednesdayHoursHTML}
                              ${thursdayHoursHTML}
                              ${fridayHoursHTML}
                              ${saturdayHoursHTML}
                              ${sundayHoursHTML}
                              </tbody>
                            </table>`;

                // Hours Modal
                officeHours.innerHTML = hoursOffice;
            }
        }
    },

    /**
    * Load Locations (For Contact page Location Widget)
    */
    async loadLocationsContact(contactLocationID) {
        if (contactLocationID) {
            CwLoadModules.modals().then((modals) => {
                const officeHours = new modals('.cw-modal');
                officeHours.init();
            });
            const apiURL = `/api/location/${contactLocationID.value}/`;                     
            //const apiURL = `http://127.0.0.1/levininjuryfirm.cwdevelop.com/api/location/${contactLocationID.value}/`;            
            const officeBox = document.querySelector('.office-info-contact');
            const officeMap = document.querySelector('.office-map-contact');
            const officeHours = document.querySelector('.opening-hours');
            const officeInfo = await fetch(apiURL);
            const officeDetails = await officeInfo.json();

            if (officeDetails.success) {
                const {
                    firmName,
                    directionURL,
                    infoURL,
                    city,
                    state,
                    zip,
                    location_address_1,
                    location_address_2,
                    phone,
                    email,
                    toll_free_number,
                    location_fax,
                    footer_map,
                    monday_hours,
                    tuesday_hours,
                    wednesday_hours,
                    thursday_hours,
                    friday_hours,
                    saturday_hours,
                    sunday_hours,
                } = officeDetails.data;

                const firmNameHTML = firmName ? `<strong>${firmName}</strong>` : '';
                const address1HTML = location_address_1 ?
                    `<span>${location_address_1}</span>` :
                    '';
                const address2HTML = location_address_2 ?
                    `<span>${location_address_2}</span>` :
                    '';
                const phoneHTML = phone ?
                    `<a href="tel:${phone}" class="ctm-no-swap" aria-label="Phone">Local: ${phone}</a>` :
                    '';
                const toll_free_numberHTML = toll_free_number ?
                    `<a href="tel:${toll_free_number}" aria-label="Phone">Toll Free: ${toll_free_number}</a>` :
                    '';    
                const emailHTML = email ?
                    `<a href="mailto:${email}" aria-label="Email Address">${email}</a>` :
                    '';
                const officeInfoButtons = `<div class="office-info__buttons">
                   <a href="${infoURL}" aria-label="Direction Link">Info <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                      <g clip-path="url(#clip0_647_772)">
                        <path d="M12.6667 0H3.33333C1.49533 0 0 1.49533 0 3.33333V12.6667C0 14.5047 1.49533 16 3.33333 16H12.6667C14.5047 16 16 14.5047 16 12.6667V3.33333C16 1.49533 14.5047 0 12.6667 0ZM12.6667 9.33333C12.6667 9.70133 12.3687 10 12 10C11.6313 10 11.3333 9.70133 11.3333 9.33333V5.60933L4.47133 12.4713C4.34133 12.6013 4.17067 12.6667 4 12.6667C3.82933 12.6667 3.65867 12.6013 3.52867 12.4713C3.268 12.2107 3.268 11.7893 3.52867 11.5287L10.3907 4.66667H6.66667C6.298 4.66667 6 4.368 6 4C6 3.632 6.298 3.33333 6.66667 3.33333H10.6667C11.7693 3.33333 12.6667 4.23067 12.6667 5.33333V9.33333Z" fill="#28A8C8"/>
                      </g>
                          <defs>
                            <clipPath id="clip0_647_772">
                              <rect width="16" height="16" fill="white"/>
                            </clipPath>
                          </defs>
                        </svg>
                    </a>

                   <a href="${directionURL}" target="_blank" aria-label="Direction Link">Directions <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                      <g clip-path="url(#clip0_647_772)">
                        <path d="M12.6667 0H3.33333C1.49533 0 0 1.49533 0 3.33333V12.6667C0 14.5047 1.49533 16 3.33333 16H12.6667C14.5047 16 16 14.5047 16 12.6667V3.33333C16 1.49533 14.5047 0 12.6667 0ZM12.6667 9.33333C12.6667 9.70133 12.3687 10 12 10C11.6313 10 11.3333 9.70133 11.3333 9.33333V5.60933L4.47133 12.4713C4.34133 12.6013 4.17067 12.6667 4 12.6667C3.82933 12.6667 3.65867 12.6013 3.52867 12.4713C3.268 12.2107 3.268 11.7893 3.52867 11.5287L10.3907 4.66667H6.66667C6.298 4.66667 6 4.368 6 4C6 3.632 6.298 3.33333 6.66667 3.33333H10.6667C11.7693 3.33333 12.6667 4.23067 12.6667 5.33333V9.33333Z" fill="#28A8C8"/>
                      </g>
                      <defs>
                        <clipPath id="clip0_647_772">
                          <rect width="16" height="16" fill="white"/>
                        </clipPath>
                      </defs>
                    </svg>
                    </a>                   
               </div>`;

                const footerMapHTML = footer_map ?
                    `<figure><a href="${directionURL}" target="_blank" aria-label="Direction Link"><img src="${footer_map}" alt="${firmName}" /><svg width="50" height="50" viewBox="0 0 60 60" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <rect width="60" height="60" rx="30" fill="#28A8C8" fill-opacity="0.9"/>
                        <path d="M30 13.5C23.3657 13.5 18 18.8051 18 25.3644C18 32.4322 25.5771 42.178 28.6971 45.8898C29.3829 46.7034 30.6343 46.7034 31.32 45.8898C34.4229 42.178 42 32.4322 42 25.3644C42 18.8051 36.6343 13.5 30 13.5ZM30 29.6017C27.6343 29.6017 25.7143 27.7034 25.7143 25.3644C25.7143 23.0254 27.6343 21.1271 30 21.1271C32.3657 21.1271 34.2857 23.0254 34.2857 25.3644C34.2857 27.7034 32.3657 29.6017 30 29.6017Z" fill="#030919"/>
                        </svg>
                     </a></figure>` :
                    '';

                const address = `${firmNameHTML}
               <address>
                   ${address1HTML}
                   ${address2HTML}
                   <span>${city}, ${state} ${zip}</span>
               </address>
               ${phoneHTML}
               ${toll_free_numberHTML}<br>
               ${emailHTML}${officeInfoButtons}
               ${footerMapHTML}`;
                officeBox.innerHTML = address;

                const mondayHoursHTML = monday_hours ?
                    `<tr><td class="day">Monday</td><td class="time"><span>${monday_hours}</span></td></tr>` :
                    '';
                const tuesdayHoursHTML = tuesday_hours ?
                    `<tr><td class="day">Tuesday</td><td class="time"><span>${tuesday_hours}</span></td></tr>` :
                    '';
                const wednesdayHoursHTML = wednesday_hours ?
                    `<tr><td class="day">Wednesday</td><td class="time"><span>${wednesday_hours}</span></td></tr>` :
                    '';
                const thursdayHoursHTML = thursday_hours ?
                    `<tr><td class="day">Thursday</td><td class="time"><span>${thursday_hours}</span></td></tr>` :
                    '';
                const fridayHoursHTML = friday_hours ?
                    `<tr><td class="day">Friday</td><td class="time"><span>${friday_hours}</span></td></tr>` :
                    '';
                const saturdayHoursHTML = saturday_hours ?
                    `<tr><td class="day">Saturday</td><td class="time"><span>${saturday_hours}</span></td></tr>` :
                    '';
                const sundayHoursHTML = sunday_hours ?
                    `<tr><td class="day">Sunday</td><td class="time"><span>${sunday_hours}</span></td></tr>` :
                    '';

                const hoursOffice = `<table>
                              <tbody>
                              ${mondayHoursHTML}
                              ${tuesdayHoursHTML}
                              ${wednesdayHoursHTML}
                              ${thursdayHoursHTML}
                              ${fridayHoursHTML}
                              ${saturdayHoursHTML}
                              ${sundayHoursHTML}
                              </tbody>
                            </table>`;

                // Hours Modal
                officeHours.innerHTML = hoursOffice;
            }
        }
    },

    /**
     * Mobile Menu
     */
    mobileMenu() {
        const mobileButton = document.querySelector('.mobile-button');
        const mobileMenuElement = document.querySelector('#mmenu');
        const mobileChecker = document.querySelector('.mm-ocd');

        if (mobileButton && mobileMenuElement) {
            // Call mmenujs module
            CwLoadModules.mmenu().then((MmenuLight) => {
                if (!mobileChecker) {
                    const menu = new MmenuLight(mobileMenuElement);
                    menu.navigation();
                    const drawer = menu.offcanvas();

                    // Register event for listening to clicks
                    mobileButton.addEventListener('click', () => drawer.open());

                    /**
                     * Close Button
                     */
                    const closeButton = document.querySelector('.close__mobileMenu');

                    closeButton.addEventListener('click', () => drawer.close());

                    /**
                     *  Appending a click option for link tags
                     * with a hash(#) symbol at the beginning of the href
                     * */

                    const aHashTag = mobileMenuElement.querySelectorAll('a[href="#"]');
                    aHashTag.forEach((tag) => {
                        tag.addEventListener('click', (event) => {
                            event.target.parentNode.click();
                            event.preventDefault();
                        });
                    });
                }
            });
        }
    },

    showContent() {        
        // Select the elements
        const showMoreContent = document.getElementById('show-more-content');
        const showMoreBtn = document.getElementById('show-more');
        const showLessBtn = document.getElementById('show-less');

        // Initially hide the content (equivalent to $('#show-more-content').hide())
        if (showMoreContent) showMoreContent.style.display = 'none';

        // Show more click event
        showMoreBtn?.addEventListener('click', function() {
            showMoreContent.style.display = 'block';
            showLessBtn.style.display = 'block';
            this.style.display = 'none'; // 'this' refers to showMoreBtn
        });

        // Show less click event
        showLessBtn?.addEventListener('click', function() {
            showMoreContent.style.display = 'none';
            showMoreBtn.style.display = 'block';
            this.style.display = 'none'; // 'this' refers to showLessBtn
        });
    },
    
};

export default CwThemeFramework;